.bam-contact-teaser__host {
  display: block;
  height: 100%;

  &.is-consultant-widget {
    padding-left: 0 !important;
    padding-right: 0 !important;

    &.is-centered-svg {
      .bam-contact-teaser__image-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    @include desktop() {
      position: relative;
      margin-top: -14rem;
      padding-right: 1rem !important;
    }

    @include tablet() {
      .bam-contact-teaser__card {
        display: flex;
      }
      .bam-contact-teaser__image-wrapper {
        width: 209px;
        max-height: 315px;
      }
    }
    &:not(.is-consultant-ch-widget) {
      .bam-contact-teaser__details {
        height: 100%;
        max-height: 315px;
      }
    }

    &.has-interferer-area {
      @include desktop() {
        margin-top: -20rem;
      }
    }
  }

  &.is-agency-ch {
    bal-card {
      display: flex;
      min-height: auto !important;
    }

    .bam-contact-teaser__details-container {
      min-width: 60%;
    }

    .bam-contact-teaser__image-container {
      flex-grow: 1;
      width: auto;
      padding-right: 0 !important;
    }

    .bam-contact-teaser__image-wrapper {
      max-width: 80px;

      @include tablet() {
        max-width: 93px;
      }

      @include desktop() {
        max-width: 120px;
      }
    }

    bal-button {
      .button {
        @include desktop() {
          min-height: 48px;
          max-height: unset;
          padding: 10px 24px;
        }
      }

      .button-label {
        @include desktop() {
          font-size: var(--bal-text-size-normal) !important; //ds update CHECK var
          line-height: 1.5 !important;
        }
      }
    }
  }
}

.bam-contact-teaser__card {
  overflow: hidden;

  &[app-type='agent'] {
    @include tablet() {
      display: flex;
    }

    .bam-contact-teaser__image-wrapper {
      margin: 0 auto;
    }
  }

  &[app-type='contactModule'] {
    border-radius: 0 !important;
  }

  &:not([app-type='lead']) {
    min-height: 448px;

    @include tablet() {
      min-height: 350px;
      &[app-type='agency'] {
        display: flex !important;
      }
    }

    @include desktop() {
      min-height: 320px;
      display: flex !important;
    }
  }
}

.bam-contact-teaser__image-wrapper {
  width: 172px;
  height: 100%;
  max-height: 256px;

  @include tablet() {
    width: 100px;
    max-height: 150px;
  }

  @include desktop() {
    width: 191px;
    max-height: 288px;
  }

  & > div[slot='image'] {
    height: 100%;
  }

  .bam-image__imageContainer {
    height: 100%;
  }

  picture {
    height: 100%;
    display: flex;
  }

  .bam-contact-teaser__card[app-type='lead'] & {
    width: 100px;
    max-height: 150px;

    @include tablet() {
      width: 191px;
      max-height: 288px;
    }
  }

  .bam-contact-teaser__card[app-type='agent'] & {
    width: 172px;
    max-height: 256px;

    @include tablet() {
      width: 191px;
      max-height: 288px;
    }
  }

  .bam-contact-teaser__card[app-type='agency'] & {
    width: 209px;
    max-height: 315px;
  }
}

.bam-contact-teaser__details-container {
  background-color: var(--bal-color-white);
  width: 100%;
}

.bam-contact-teaser__shape {
  position: absolute;
  right: -44px;
  bottom: 0;
  width: 66px;
  height: 66px;

  @include tablet() {
    width: 120px;
    height: 120px;
    right: -80px;
  }

  @include desktop() {
    width: 198px;
    height: 198px;
    right: -132px;
  }
}

.bam-contact-teaser__social {
  padding-top: 16px;
}
